import data from './tunables.json';

/** Every number the game and sim use. Edit tunables.json, never inline a value. */
export type Tunables = typeof data;
export const tunables: Tunables = data;
